import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, withKeys as _withKeys, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = {
  class: "export-layout-designer flex flex-1 overflow-hidden"
};
const _hoisted_2 = {
  class: "w-56 bg-white border-r border-slate-200 flex flex-col shrink-0"
};
const _hoisted_3 = {
  class: "flex-1 overflow-y-auto p-3 space-y-4"
};
const _hoisted_4 = {
  class: "space-y-2"
};
const _hoisted_5 = ["onDragstart"];
const _hoisted_6 = {
  class: "text-sm text-slate-700 truncate"
};
const _hoisted_7 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_8 = {
  class: "space-y-2"
};
const _hoisted_9 = ["onDragstart"];
const _hoisted_10 = {
  class: "text-sm text-slate-700 truncate"
};
const _hoisted_11 = {
  class: "p-3 bg-primary-50 rounded-lg border border-primary-100"
};
const _hoisted_12 = {
  class: "flex items-start gap-2"
};
const _hoisted_13 = {
  class: "flex-1 flex flex-col min-h-0 bg-slate-100/50"
};
const _hoisted_14 = {
  key: 0,
  class: "flex items-center justify-center h-80 text-slate-400"
};
const _hoisted_15 = {
  class: "text-center"
};
const _hoisted_16 = {
  key: 1,
  class: "max-w-3xl mx-auto"
};
const _hoisted_17 = ["data-row-id", "onClick", "onKeydown"];
const _hoisted_18 = {
  class: "absolute -top-2.5 right-2 flex gap-1 opacity-60 group-hover:opacity-100 focus-within:opacity-100 transition-opacity z-10"
};
const _hoisted_19 = ["disabled", "onClick"];
const _hoisted_20 = ["disabled", "onClick"];
const _hoisted_21 = ["onClick"];
const _hoisted_22 = ["onDrop", "onDragenter", "onDragleave"];
const _hoisted_23 = ["draggable", "title", "onDragstart", "onDrop", "onClick", "onKeydown"];
const _hoisted_24 = {
  key: 0,
  class: "absolute -top-2 right-0 z-20 px-1 rounded bg-primary-600 text-white text-[10px] leading-4 pointer-events-none"
};
const _hoisted_25 = {
  key: 2,
  class: "flex-1 py-1.5"
};
const _hoisted_26 = ["src", "alt", "onError"];
const _hoisted_27 = {
  key: 1,
  class: "flex items-center gap-1 px-2 py-2 border border-dashed border-slate-300 rounded text-slate-400"
};
const _hoisted_28 = {
  key: 5,
  class: "flex-1 py-1"
};
const _hoisted_29 = {
  class: "rounded border border-slate-300 overflow-hidden"
};
const _hoisted_30 = {
  class: "flex items-center h-4 px-1.5 bg-primary-100/80"
};
const _hoisted_31 = {
  class: "text-[10px] text-primary-700 truncate"
};
const _hoisted_32 = {
  key: 6,
  class: "flex-1 py-1 space-y-1.5"
};
const _hoisted_33 = {
  class: "ml-auto shrink-0 text-[10px] text-slate-400"
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = ["onMousedown"];
const _hoisted_36 = {
  key: 0,
  class: "mt-1 text-xs text-red-500"
};
const _hoisted_37 = {
  class: "max-w-3xl mx-auto mt-3"
};
const _hoisted_38 = {
  class: "w-64 bg-white border-l border-slate-200 flex flex-col shrink-0"
};
const _hoisted_39 = {
  class: "flex-1 overflow-y-auto p-4"
};
const _hoisted_40 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_41 = {
  key: 1,
  class: "space-y-4"
};
const _hoisted_42 = ["value"];
const _hoisted_43 = {
  key: 2,
  class: "space-y-4"
};
const _hoisted_44 = {
  key: 0
};
const _hoisted_45 = {
  class: "flex gap-2"
};
const _hoisted_46 = ["disabled"];
const _hoisted_47 = ["disabled"];
const _hoisted_48 = ["value"];
const _hoisted_49 = ["value"];
const _hoisted_50 = {
  key: 0,
  class: "mt-1 text-xs text-amber-600"
};
const _hoisted_51 = {
  class: "form-switch"
};
const _hoisted_52 = ["value"];
const _hoisted_53 = {
  key: 0,
  class: "mt-1 text-xs text-amber-600"
};
const _hoisted_54 = {
  class: "flex items-center gap-2"
};
const _hoisted_55 = {
  class: "flex items-center gap-2"
};
const _hoisted_56 = {
  class: "flex items-center gap-2"
};
const _hoisted_57 = {
  key: 6
};
const _hoisted_58 = {
  key: 0,
  class: "mt-1 text-xs text-amber-600"
};
const _hoisted_59 = {
  class: "flex items-center gap-2"
};
const _hoisted_60 = {
  key: 9
};
import { ref, computed, watch, nextTick, onBeforeUnmount } from 'vue';
import { ElMessage } from 'element-plus';
import { Edit, Tickets, Document, InfoFilled, Grid, Plus, Delete, ArrowUp, ArrowDown, ArrowLeft, ArrowRight, WarningFilled, Minus, Expand, Picture, Calendar, List, Money, Phone, Upload, Switch, Link, Message as MessageIcon } from '@element-plus/icons-vue';
import FileUpload from '@/components/FileUpload.vue';
import { getFileUrl } from '@/api/file';
import { EXPORT_LAYOUT_VERSION, GRID_SPAN_TOTAL, BLOCK_ELEMENT_TYPES, ELEMENT_TYPE_STATIC, ELEMENT_TYPE_FIELD, ELEMENT_TYPE_DETAIL_TABLE, ELEMENT_TYPE_APPROVAL_TRAIL, ELEMENT_TYPE_DIVIDER, ELEMENT_TYPE_SPACER, ELEMENT_TYPE_IMAGE, DIVIDER_DEFAULT_THICKNESS, DIVIDER_DEFAULT_COLOR, SPACER_DEFAULT_HEIGHT, IMAGE_DEFAULT_WIDTH, SYSTEM_FIELDS, collectInvalidFieldKeys, isFieldShowLabel, effectiveSpan } from '@/utils/workflowExportLayout';
export default {
  __name: 'ExportLayoutDesigner',
  props: {
    // 模板当前表单字段（FormDesigner getFieldList 结构：key/label/type/summary），实时同步
    fields: {
      type: Array,
      default: () => []
    },
    // 已有导出布局（加载模板回填），null 表示未配置
    initialLayout: {
      type: Object,
      default: null
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const props = __props;

    // 行数据：[{ id, spacingBefore?, spacingAfter?, elements: [...] }]，元素结构与 export_layout 模型一致（spec §3）
    const rows = ref([]);
    const selectedElement = ref(null);
    const selectedRow = ref(null);
    // 空行拖拽悬停高亮（行索引，null 表示无悬停）
    const dragOverRowIndex = ref(null);
    let idSeq = 0;

    // 放置完成（rows 变化）后清除空行悬停高亮
    watch(rows, () => {
      dragOverRowIndex.value = null;
    }, {
      deep: true
    });
    function nextId(prefix) {
      idSeq += 1;
      return `${prefix}_${Date.now().toString(36)}_${idSeq}`;
    }
    function initRows(layout) {
      if (!layout || !Array.isArray(layout.rows)) {
        rows.value = [];
        return;
      }
      rows.value = layout.rows.map(row => ({
        id: row.id || nextId('row'),
        spacingBefore: row.spacingBefore,
        spacingAfter: row.spacingAfter,
        elements: (row.elements || []).map(el => {
          const element = {
            ...el,
            id: el.id || nextId('el')
          };
          // FIELD showLabel 默认 true：存量布局无此属性视为 true（spec 增强批 A）
          if (element.type === ELEMENT_TYPE_FIELD && element.showLabel == null) element.showLabel = true;
          return element;
        })
      }));
      // IMAGE 预览 url 不随布局持久化（预签名地址有时效），回填时按 fileKey 现取
      rows.value.forEach(row => row.elements.forEach(el => {
        if (el.type === ELEMENT_TYPE_IMAGE && el.fileKey) refreshImagePreview(el);
      }));
    }

    // 加载模板回填（与 FormDesigner watch initialForm 同款模式）
    watch(() => props.initialLayout, layout => {
      initRows(layout);
      selectedElement.value = null;
      selectedRow.value = null;
    }, {
      immediate: true
    });

    // 字段占位面板：顶层非 DETAIL 字段 + summary.targetKey 虚拟字段 + 系统字段白名单（spec §3.1/§5.1）
    const fieldPanelItems = computed(() => {
      const items = [];
      (props.fields || []).forEach(field => {
        if (!field) return;
        if (field.type === 'DETAIL') {
          (field.summary || []).forEach(sum => {
            if (sum?.targetKey) {
              // 汇总虚拟字段无独立类型，取汇总列子字段类型做图标区分（查不到回退默认文本图标）
              const childType = (field.children || []).find(c => c?.key === sum.column)?.type;
              items.push({
                kind: ELEMENT_TYPE_FIELD,
                fieldKey: sum.targetKey,
                label: `${field.label}·${sum.label || sum.targetKey}`,
                type: childType
              });
            }
          });
          return;
        }
        if (field.key) {
          items.push({
            kind: ELEMENT_TYPE_FIELD,
            fieldKey: field.key,
            label: field.label,
            type: field.type
          });
        }
      });
      SYSTEM_FIELDS.forEach(sys => {
        // 系统字段固定语义：提交时间按日期时间图标，其余按文本图标
        items.push({
          kind: ELEMENT_TYPE_FIELD,
          fieldKey: sys.key,
          label: `${sys.label}（系统）`,
          type: sys.key === 'createTime' ? 'DATETIME' : 'TEXT'
        });
      });
      return items;
    });

    // 块级元素面板：每个 DETAIL 字段一个"明细表格"块 + 审批轨迹块 + 分隔线/空白行/图片
    const blockPanelItems = computed(() => {
      const items = (props.fields || []).filter(field => field?.type === 'DETAIL' && field.key).map(field => ({
        kind: ELEMENT_TYPE_DETAIL_TABLE,
        fieldKey: field.key,
        label: `明细表格：${field.label}`
      }));
      items.push({
        kind: ELEMENT_TYPE_APPROVAL_TRAIL,
        label: '审批轨迹'
      });
      items.push({
        kind: ELEMENT_TYPE_DIVIDER,
        label: '分隔线'
      });
      items.push({
        kind: ELEMENT_TYPE_SPACER,
        label: '空白行'
      });
      items.push({
        kind: ELEMENT_TYPE_IMAGE,
        label: '图片'
      });
      return items;
    });

    // 块级元素面板图标
    const BLOCK_PANEL_ICONS = {
      [ELEMENT_TYPE_DETAIL_TABLE]: Tickets,
      [ELEMENT_TYPE_APPROVAL_TRAIL]: Tickets,
      [ELEMENT_TYPE_DIVIDER]: Minus,
      [ELEMENT_TYPE_SPACER]: Expand,
      [ELEMENT_TYPE_IMAGE]: Picture
    };
    function blockPanelIcon(kind) {
      return BLOCK_PANEL_ICONS[kind] || Tickets;
    }

    // 字段类型图标/配色（与 FormDesigner fieldTypes 保持一致，左面板字段项按 type 区分）
    const FIELD_TYPE_PANEL_STYLES = {
      TEXT: {
        icon: Edit,
        iconClass: 'text-blue-600'
      },
      TEXTAREA: {
        icon: Document,
        iconClass: 'text-blue-600'
      },
      NUMBER: {
        icon: Edit,
        iconClass: 'text-green-600'
      },
      MONEY: {
        icon: Money,
        iconClass: 'text-green-600'
      },
      DETAIL: {
        icon: Tickets,
        iconClass: 'text-rose-600'
      },
      DATE: {
        icon: Calendar,
        iconClass: 'text-purple-600'
      },
      DATETIME: {
        icon: Calendar,
        iconClass: 'text-purple-600'
      },
      SELECT: {
        icon: List,
        iconClass: 'text-orange-600'
      },
      RADIO: {
        icon: List,
        iconClass: 'text-orange-600'
      },
      CHECKBOX: {
        icon: List,
        iconClass: 'text-orange-600'
      },
      EMAIL: {
        icon: MessageIcon,
        iconClass: 'text-cyan-600'
      },
      PHONE: {
        icon: Phone,
        iconClass: 'text-cyan-600'
      },
      FILE: {
        icon: Upload,
        iconClass: 'text-red-600'
      },
      SWITCH: {
        icon: Switch,
        iconClass: 'text-teal-600'
      },
      URL: {
        icon: Link,
        iconClass: 'text-indigo-600'
      }
    };
    function fieldTypeIcon(type) {
      return (FIELD_TYPE_PANEL_STYLES[type] || FIELD_TYPE_PANEL_STYLES.TEXT).icon;
    }
    function fieldTypeIconClass(type) {
      return (FIELD_TYPE_PANEL_STYLES[type] || FIELD_TYPE_PANEL_STYLES.TEXT).iconClass;
    }

    // 元素条类型徽章：短文案 + 配色（字段/文本与字段面板一致，块级与块级面板玫瑰色一致）
    const ELEMENT_TYPE_BADGES = {
      [ELEMENT_TYPE_FIELD]: {
        text: '字段',
        badgeClass: 'bg-blue-50 text-blue-600'
      },
      [ELEMENT_TYPE_STATIC]: {
        text: '文本',
        badgeClass: 'bg-slate-100 text-slate-500'
      },
      [ELEMENT_TYPE_DETAIL_TABLE]: {
        text: '表格',
        badgeClass: 'bg-rose-50 text-rose-600'
      },
      [ELEMENT_TYPE_APPROVAL_TRAIL]: {
        text: '轨迹',
        badgeClass: 'bg-rose-50 text-rose-600'
      },
      [ELEMENT_TYPE_DIVIDER]: {
        text: '分隔线',
        badgeClass: 'bg-slate-100 text-slate-500'
      },
      [ELEMENT_TYPE_SPACER]: {
        text: '空白行',
        badgeClass: 'bg-slate-100 text-slate-500'
      },
      [ELEMENT_TYPE_IMAGE]: {
        text: '图片',
        badgeClass: 'bg-rose-50 text-rose-600'
      }
    };
    function elementTypeBadgeText(type) {
      return ELEMENT_TYPE_BADGES[type]?.text || type;
    }
    function elementTypeBadgeClass(type) {
      return ELEMENT_TYPE_BADGES[type]?.badgeClass || 'bg-slate-100 text-slate-500';
    }
    const staticPanelItem = {
      kind: ELEMENT_TYPE_STATIC
    };

    // fieldKey → 显示名（画布元素标签；失效 key 回退显示原始 fieldKey）
    const fieldLabelMap = computed(() => {
      const map = {};
      fieldPanelItems.value.forEach(item => {
        map[item.fieldKey] = item.label;
      });
      (props.fields || []).forEach(field => {
        if (field?.type === 'DETAIL' && field.key) map[field.key] = field.label;
      });
      return map;
    });

    // 失效占位（引用已删除字段）标黄警示（spec §3.2 UX 决策 a）
    const invalidFieldKeys = computed(() => collectInvalidFieldKeys({
      rows: rows.value
    }, props.fields));
    function isElementInvalid(element) {
      return [ELEMENT_TYPE_FIELD, ELEMENT_TYPE_DETAIL_TABLE].includes(element.type) && invalidFieldKeys.value.has(element.fieldKey);
    }
    function elementLabel(element) {
      if (element.type === ELEMENT_TYPE_STATIC) return element.content || '静态文本';
      if (element.type === ELEMENT_TYPE_FIELD) {
        const label = fieldLabelMap.value[element.fieldKey] || element.fieldKey;
        // showLabel 开启时画布占位显示"标签：预览值"形态（导出语义为"标签：值"）
        return isFieldShowLabel(element) ? `${label}：预览值` : label;
      }
      if (element.type === ELEMENT_TYPE_DETAIL_TABLE) return `明细表格：${fieldLabelMap.value[element.fieldKey] || element.fieldKey}`;
      if (element.type === ELEMENT_TYPE_APPROVAL_TRAIL) return '审批轨迹';
      if (element.type === ELEMENT_TYPE_DIVIDER) return '分隔线';
      if (element.type === ELEMENT_TYPE_SPACER) return `空白行（${element.height ?? SPACER_DEFAULT_HEIGHT} 磅）`;
      if (element.type === ELEMENT_TYPE_IMAGE) return element.fileName || (element.fileKey ? '图片' : '图片（未上传）');
      return element.type;
    }
    function elementTypeLabel(type) {
      const labels = {
        STATIC: '静态文本',
        FIELD: '字段占位',
        DETAIL_TABLE: '明细表格',
        APPROVAL_TRAIL: '审批轨迹',
        DIVIDER: '分隔线',
        SPACER: '空白行',
        IMAGE: '图片'
      };
      return labels[type] || type;
    }

    // STATIC/FIELD 画布文字颜色预览
    function elementTextStyle(element) {
      if (![ELEMENT_TYPE_STATIC, ELEMENT_TYPE_FIELD].includes(element.type)) return {};
      return element.color ? {
        color: element.color
      } : {};
    }

    // 磅 → 画布像素（1pt ≈ 4/3px，仅用于视觉预览）
    function ptToPx(pt) {
      return Math.round((Number(pt) || 0) * 4 / 3);
    }

    // 空白行预览高度按比例视觉化，封顶避免画布被撑得过高
    function spacerPreviewHeight(element) {
      return Math.min(Math.max(ptToPx(element.height ?? SPACER_DEFAULT_HEIGHT), 12), 160);
    }
    function imageAlignClass(element) {
      if (element.align === 'left') return 'justify-start';
      if (element.align === 'right') return 'justify-end';
      return 'justify-center';
    }

    // 行间距视觉体现：行间 gap = 12px 基础间距 + 上一行行后间距 + 本行行前间距
    function rowGapStyle(rowIndex) {
      if (rowIndex === 0) return {};
      const prev = rows.value[rowIndex - 1];
      const gap = 12 + ptToPx(prev.spacingAfter) + ptToPx(rows.value[rowIndex].spacingBefore);
      return {
        marginTop: `${gap}px`
      };
    }
    function rowSpanSum(row) {
      return row.elements.reduce((acc, el) => acc + (Number(el.span) || 0), 0);
    }
    function isRowOverflow(row) {
      return rowSpanSum(row) > GRID_SPAN_TOTAL;
    }

    // 面板拖拽开始
    function onPanelDragStart(event, item) {
      event.dataTransfer.setData('exportElement', JSON.stringify(item));
    }

    // 画布元素拖拽开始（行内/跨行移动；块级元素不可拖，用行排序代替）
    function onElementDragStart(event, rowIndex, elementIndex) {
      event.dataTransfer.setData('exportElementMove', JSON.stringify({
        rowIndex,
        elementIndex
      }));
    }
    function createElement(item) {
      const base = {
        id: nextId('el'),
        type: item.kind
      };
      if (item.kind === ELEMENT_TYPE_STATIC) {
        return {
          ...base,
          content: '静态文本',
          span: 6,
          align: 'left',
          bold: false,
          fontSize: 14,
          color: '#000000'
        };
      }
      if (item.kind === ELEMENT_TYPE_FIELD) {
        return {
          ...base,
          fieldKey: item.fieldKey,
          span: 6,
          align: 'left',
          bold: false,
          fontSize: 14,
          color: '#000000',
          showLabel: true
        };
      }
      if (item.kind === ELEMENT_TYPE_DETAIL_TABLE) {
        return {
          ...base,
          fieldKey: item.fieldKey,
          span: GRID_SPAN_TOTAL,
          border: true
        };
      }
      if (item.kind === ELEMENT_TYPE_DIVIDER) {
        return {
          ...base,
          span: GRID_SPAN_TOTAL,
          thickness: DIVIDER_DEFAULT_THICKNESS,
          color: DIVIDER_DEFAULT_COLOR
        };
      }
      if (item.kind === ELEMENT_TYPE_SPACER) {
        return {
          ...base,
          span: GRID_SPAN_TOTAL,
          height: SPACER_DEFAULT_HEIGHT
        };
      }
      if (item.kind === ELEMENT_TYPE_IMAGE) {
        return {
          ...base,
          span: GRID_SPAN_TOTAL,
          fileKey: '',
          url: '',
          fileName: '',
          width: IMAGE_DEFAULT_WIDTH,
          align: 'center'
        };
      }
      // APPROVAL_TRAIL
      return {
        ...base,
        span: GRID_SPAN_TOTAL,
        showComment: true,
        showTime: true
      };
    }
    function addRow() {
      rows.value.push({
        id: nextId('row'),
        elements: []
      });
    }

    // 删除没有元素的空行（校验层不处理空行，输出前也会剔除）
    function cleanupEmptyRow(rowIndex) {
      if (rows.value[rowIndex] && rows.value[rowIndex].elements.length === 0) {
        if (selectedRow.value === rows.value[rowIndex]) selectedRow.value = null;
        rows.value.splice(rowIndex, 1);
      }
    }

    // 目标行是否被块级元素独占（独占行不能再放入其他元素）
    function isBlockOnlyRow(row) {
      return row.elements.some(el => BLOCK_ELEMENT_TYPES.includes(el.type));
    }

    // 画布空白区放置：新起一行
    function onCanvasDrop(event) {
      const elementData = event.dataTransfer.getData('exportElement');
      if (!elementData) return;
      const element = createElement(JSON.parse(elementData));
      rows.value.push({
        id: nextId('row'),
        elements: [element]
      });
      selectedElement.value = element;
      selectedRow.value = null;
    }

    // 空行拖拽悬停高亮：仅对空行记录悬停行
    function onRowDragEnter(event, rowIndex) {
      if (rows.value[rowIndex].elements.length > 0) return;
      dragOverRowIndex.value = rowIndex;
    }

    // 离开行容器时清除高亮（进入行内子元素不算离开）
    function onRowDragLeave(event, rowIndex) {
      if (event.currentTarget.contains(event.relatedTarget)) return;
      if (dragOverRowIndex.value === rowIndex) dragOverRowIndex.value = null;
    }

    // 行内放置（行尾空白区）
    function onRowDrop(event, rowIndex) {
      const elementData = event.dataTransfer.getData('exportElement');
      if (elementData) {
        const element = createElement(JSON.parse(elementData));
        if (BLOCK_ELEMENT_TYPES.includes(element.type)) {
          // 块级元素独占整行：目标行非空则紧邻其后新起一行
          if (rows.value[rowIndex].elements.length > 0) {
            rows.value.splice(rowIndex + 1, 0, {
              id: nextId('row'),
              elements: [element]
            });
          } else {
            rows.value[rowIndex].elements.push(element);
          }
          selectedElement.value = element;
          selectedRow.value = null;
          return;
        }
        if (isBlockOnlyRow(rows.value[rowIndex])) {
          ElMessage.warning('块级元素独占整行，不能再放入其他元素');
          return;
        }
        rows.value[rowIndex].elements.push(element);
        selectedElement.value = element;
        selectedRow.value = null;
        return;
      }
      const moveData = event.dataTransfer.getData('exportElementMove');
      if (moveData) {
        const {
          rowIndex: fromRow,
          elementIndex: fromIndex
        } = JSON.parse(moveData);
        if (fromRow === rowIndex) return;
        if (isBlockOnlyRow(rows.value[rowIndex])) {
          ElMessage.warning('块级元素独占整行，不能再放入其他元素');
          return;
        }
        const [moved] = rows.value[fromRow].elements.splice(fromIndex, 1);
        rows.value[rowIndex].elements.push(moved);
        cleanupEmptyRow(fromRow);
        selectedElement.value = moved;
        selectedRow.value = null;
      }
    }

    // 放置到具体元素位置（插入其前）
    function onElementDrop(event, rowIndex, elementIndex) {
      const elementData = event.dataTransfer.getData('exportElement');
      if (elementData) {
        const item = JSON.parse(elementData);
        if (BLOCK_ELEMENT_TYPES.includes(item.kind)) {
          // 块级元素交给行级逻辑（独占整行）
          onRowDrop(event, rowIndex);
          return;
        }
        if (isBlockOnlyRow(rows.value[rowIndex])) {
          ElMessage.warning('块级元素独占整行，不能再放入其他元素');
          return;
        }
        const element = createElement(item);
        rows.value[rowIndex].elements.splice(elementIndex, 0, element);
        selectedElement.value = element;
        selectedRow.value = null;
        return;
      }
      const moveData = event.dataTransfer.getData('exportElementMove');
      if (moveData) {
        const {
          rowIndex: fromRow,
          elementIndex: fromIndex
        } = JSON.parse(moveData);
        if (fromRow === rowIndex && (fromIndex === elementIndex || fromIndex === elementIndex - 1)) return;
        const row = rows.value[rowIndex];
        if (isBlockOnlyRow(row)) {
          ElMessage.warning('块级元素独占整行，不能再放入其他元素');
          return;
        }
        const [moved] = rows.value[fromRow].elements.splice(fromIndex, 1);
        const insertIndex = fromRow === rowIndex && fromIndex < elementIndex ? elementIndex - 1 : elementIndex;
        row.elements.splice(insertIndex, 0, moved);
        cleanupEmptyRow(fromRow);
        selectedElement.value = moved;
        selectedRow.value = null;
      }
    }
    function moveRowUp(rowIndex) {
      if (rowIndex <= 0) return;
      const [row] = rows.value.splice(rowIndex, 1);
      rows.value.splice(rowIndex - 1, 0, row);
    }
    function moveRowDown(rowIndex) {
      if (rowIndex >= rows.value.length - 1) return;
      const [row] = rows.value.splice(rowIndex, 1);
      rows.value.splice(rowIndex + 1, 0, row);
    }

    // 选中元素在行内的位置（属性面板左移/右移按钮用）
    const selectedElementLocation = computed(() => {
      const el = selectedElement.value;
      if (!el) return null;
      for (let rowIndex = 0; rowIndex < rows.value.length; rowIndex++) {
        const elementIndex = rows.value[rowIndex].elements.indexOf(el);
        if (elementIndex !== -1) return {
          rowIndex,
          elementIndex
        };
      }
      return null;
    });

    // 行内换位（与拖拽行内移动同一换位效果：与相邻元素互换位置），供左移/右移按钮复用
    function moveElement(rowIndex, elementIndex, direction) {
      const row = rows.value[rowIndex];
      if (!row) return;
      const targetIndex = elementIndex + direction;
      if (targetIndex < 0 || targetIndex >= row.elements.length) return;
      const temp = row.elements[elementIndex];
      row.elements[elementIndex] = row.elements[targetIndex];
      row.elements[targetIndex] = temp;
    }
    function canMoveSelectedElement(direction) {
      const loc = selectedElementLocation.value;
      if (!loc) return false;
      const targetIndex = loc.elementIndex + direction;
      return targetIndex >= 0 && targetIndex < rows.value[loc.rowIndex].elements.length;
    }
    function moveSelectedElement(direction) {
      const loc = selectedElementLocation.value;
      if (loc) moveElement(loc.rowIndex, loc.elementIndex, direction);
    }
    function removeRow(rowIndex) {
      const [removed] = rows.value.splice(rowIndex, 1);
      if (removed.elements.includes(selectedElement.value)) {
        selectedElement.value = null;
      }
      if (selectedRow.value === removed) selectedRow.value = null;
    }
    function selectElement(element) {
      selectedElement.value = element;
      selectedRow.value = null;
    }

    // 点击行空白处选中行（属性面板切换为行间距配置）
    function selectRow(row) {
      selectedRow.value = row;
      selectedElement.value = null;
    }

    // 键盘选中（Enter/Space）：事件源自内部按钮时不拦截，保留按钮原生键盘激活
    function onRowKeydown(event, row) {
      if (event.target !== event.currentTarget) return;
      event.preventDefault();
      selectRow(row);
    }
    function onElementKeydown(event, element) {
      if (event.target !== event.currentTarget) return;
      event.stopPropagation();
      event.preventDefault();
      selectElement(element);
    }
    function removeElement(rowIndex, elementIndex) {
      const [removed] = rows.value[rowIndex].elements.splice(elementIndex, 1);
      if (selectedElement.value === removed) selectedElement.value = null;
      cleanupEmptyRow(rowIndex);
    }

    // ---- 拖拽调宽（resize handle，原生实现，spec §5.1 新交互） ----
    // 拖拽中的实时状态 { elementId, span }，用于角标 tooltip
    const resizing = ref(null);
    let resizeState = null;
    function startResize(event, rowIndex, element) {
      if (BLOCK_ELEMENT_TYPES.includes(element.type)) return;
      event.preventDefault();
      event.stopPropagation();
      const gridEl = event.currentTarget.closest('.export-row-grid');
      if (!gridEl) return;
      const unit = gridEl.getBoundingClientRect().width / GRID_SPAN_TOTAL;
      if (unit <= 0) return;
      // 本元素最大 span = 24 - 行内其他元素 span 总和（resize 不得超过行剩余栅格）；
      // span 缺省按 24 计（effectiveSpan，与校验器口径一致）
      const othersSpan = rows.value[rowIndex].elements.filter(el => el !== element).reduce((acc, el) => acc + effectiveSpan(el), 0);
      resizeState = {
        element,
        startX: event.clientX,
        startSpan: effectiveSpan(element),
        unit,
        maxSpan: Math.max(1, GRID_SPAN_TOTAL - othersSpan)
      };
      resizing.value = {
        elementId: element.id,
        span: resizeState.startSpan
      };
      document.addEventListener('mousemove', onResizeMove);
      document.addEventListener('mouseup', onResizeEnd);
      document.body.style.userSelect = 'none';
    }
    function onResizeMove(event) {
      if (!resizeState) return;
      const delta = event.clientX - resizeState.startX;
      const span = Math.min(resizeState.maxSpan, Math.max(1, Math.round(resizeState.startSpan + delta / resizeState.unit)));
      resizeState.element.span = span;
      resizing.value = {
        elementId: resizeState.element.id,
        span
      };
    }
    function onResizeEnd() {
      if (!resizeState) return;
      document.removeEventListener('mousemove', onResizeMove);
      document.removeEventListener('mouseup', onResizeEnd);
      document.body.style.userSelect = '';
      resizeState = null;
      resizing.value = null;
    }

    // 组件卸载时清理 document 级监听，避免泄漏
    onBeforeUnmount(onResizeEnd);

    // ---- IMAGE 元素图片上传（复用 FileUpload，限图片类型、单文件、5MB） ----
    const imageFiles = computed(() => {
      const el = selectedElement.value;
      if (!el || el.type !== ELEMENT_TYPE_IMAGE || !el.fileKey) return [];
      return [{
        fileKey: el.fileKey,
        name: el.fileName || el.fileKey,
        url: el.url
      }];
    });
    function onImageFilesUpdate(files) {
      const el = selectedElement.value;
      if (!el || el.type !== ELEMENT_TYPE_IMAGE) return;
      const file = files[0];
      // 上传成功取 fileKey 存入元素；预览 url 不落库，统一按 fileKey 现取新鲜地址
      el.fileKey = file?.fileKey || '';
      el.fileName = file?.name || file?.fileName || '';
      el.url = '';
      if (el.fileKey) refreshImagePreview(el);
    }

    // 按 fileKey 现取预览 URL（私有桶预签名地址有时效，仅用于内存预览，不随布局持久化）
    function refreshImagePreview(element) {
      const fileKey = element.fileKey;
      getFileUrl(fileKey).then(url => {
        if (element.fileKey === fileKey) element.url = url || '';
      }).catch(() => {
        if (element.fileKey === fileKey) element.url = '';
      });
    }

    // 预览图加载失败（如 url 失效）回退到文件名占位
    function onImagePreviewError(element) {
      element.url = '';
    }

    // 供 WorkflowDesigner 保存时调用；空布局返回 null（不启用导出，spec §3.2）
    function getExportLayout() {
      const validRows = rows.value.filter(row => row.elements.length > 0).map(row => {
        const out = {
          id: row.id,
          elements: row.elements.map(el => {
            const element = {
              ...el
            };
            // url 为预签名临时预览地址，不随布局持久化（重开设计器时按 fileKey 现取）
            delete element.url;
            return element;
          })
        };
        if (row.spacingBefore != null) out.spacingBefore = row.spacingBefore;
        if (row.spacingAfter != null) out.spacingAfter = row.spacingAfter;
        return out;
      });
      if (validRows.length === 0) return null;
      return {
        version: EXPORT_LAYOUT_VERSION,
        rows: validRows
      };
    }

    // ---- 保存校验失败定位（WorkflowDesigner 校验失败后调用） ----
    // 校验错误文案含"第 N 行"（1-based，按 getExportLayout 剔除空行后的行序）
    const canvasRef = ref(null);
    const flashRowId = ref(null);
    let flashTimer = null;

    // 定位首个问题行：选中该行、滚动到可视区并高亮闪烁（1.5s 后自动移除）
    function locateError(message) {
      const match = /第\s*(\d+)\s*行/.exec(String(message || ''));
      if (!match) return;
      const validRows = rows.value.filter(row => row.elements.length > 0);
      const row = validRows[Number(match[1]) - 1];
      if (!row) return;
      selectRow(row);
      flashRowId.value = row.id;
      clearTimeout(flashTimer);
      flashTimer = setTimeout(() => {
        flashRowId.value = null;
      }, 1500);
      const rowEl = canvasRef.value?.querySelector(`[data-row-id="${row.id}"]`);
      // 保存入口可能在其他步骤触发：步骤面板 v-show 切换后需等 DOM 显示再滚动，否则 scrollIntoView 失效
      nextTick(() => rowEl?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      }));
    }
    onBeforeUnmount(() => clearTimeout(flashTimer));
    __expose({
      getExportLayout,
      locateError
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_color_picker = _resolveComponent("el-color-picker");
      const _component_el_radio_button = _resolveComponent("el-radio-button");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[29] || (_cache[29] = _createElementVNode("div", {
        class: "px-4 py-3 border-b border-slate-200 bg-slate-50/50"
      }, [_createElementVNode("h3", {
        class: "text-xs font-semibold text-slate-500 uppercase tracking-wider"
      }, "布局元素")], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_cache[24] || (_cache[24] = _createElementVNode("p", {
        class: "text-xs font-medium text-slate-400 mb-2"
      }, "字段占位", -1)), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fieldPanelItems.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: 'field-' + item.fieldKey,
          class: "flex items-center gap-2 px-3 py-2 bg-slate-50 hover:bg-slate-100 border border-slate-200 hover:border-primary-300 rounded-lg cursor-grab active:cursor-grabbing transition-all",
          draggable: "true",
          onDragstart: $event => onPanelDragStart($event, item)
        }, [_createVNode(_component_el_icon, {
          size: 14,
          class: _normalizeClass(["shrink-0", fieldTypeIconClass(item.type)])
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(fieldTypeIcon(item.type))))]),
          _: 2
        }, 1032, ["class"]), _createElementVNode("span", _hoisted_6, _toDisplayString(item.label), 1)], 40, _hoisted_5);
      }), 128)), fieldPanelItems.value.length === 0 ? (_openBlock(), _createElementBlock("p", _hoisted_7, " 暂无可用字段，请先在表单设计中添加字段 ")) : _createCommentVNode("", true)])]), _createElementVNode("div", null, [_cache[25] || (_cache[25] = _createElementVNode("p", {
        class: "text-xs font-medium text-slate-400 mb-2"
      }, "块级元素（独占整行）", -1)), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blockPanelItems.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.kind + '-' + (item.fieldKey || item.label),
          class: "flex items-center gap-2 px-3 py-2 bg-slate-50 hover:bg-slate-100 border border-slate-200 hover:border-primary-300 rounded-lg cursor-grab active:cursor-grabbing transition-all",
          draggable: "true",
          onDragstart: $event => onPanelDragStart($event, item)
        }, [_createVNode(_component_el_icon, {
          size: 14,
          class: "text-rose-600 shrink-0"
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(blockPanelIcon(item.kind))))]),
          _: 2
        }, 1024), _createElementVNode("span", _hoisted_10, _toDisplayString(item.label), 1)], 40, _hoisted_9);
      }), 128))])]), _createElementVNode("div", null, [_cache[27] || (_cache[27] = _createElementVNode("p", {
        class: "text-xs font-medium text-slate-400 mb-2"
      }, "静态文本", -1)), _createElementVNode("div", {
        class: "flex items-center gap-2 px-3 py-2 bg-slate-50 hover:bg-slate-100 border border-slate-200 hover:border-primary-300 rounded-lg cursor-grab active:cursor-grabbing transition-all",
        draggable: "true",
        onDragstart: _cache[0] || (_cache[0] = $event => onPanelDragStart($event, staticPanelItem))
      }, [_createVNode(_component_el_icon, {
        size: 14,
        class: "text-slate-600 shrink-0"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Document))]),
        _: 1
      }), _cache[26] || (_cache[26] = _createElementVNode("span", {
        class: "text-sm text-slate-700"
      }, "静态文本", -1))], 32)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_icon, {
        class: "text-primary-500 mt-0.5",
        size: 14
      }, {
        default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
        _: 1
      }), _cache[28] || (_cache[28] = _createElementVNode("p", {
        class: "text-xs text-primary-600"
      }, "拖拽元素到右侧画布的行中；块级元素独占整行，每行总宽不超过 24 栅格；拖动元素右缘调宽，点击行空白处配置行间距", -1))])])])]), _createElementVNode("div", _hoisted_13, [_cache[36] || (_cache[36] = _createElementVNode("div", {
        class: "px-4 py-2 bg-primary-50 border-b border-primary-100 text-xs text-primary-700 shrink-0"
      }, " 导出设计为可选步骤：不添加任何行则不启用导出。 ", -1)), _createElementVNode("div", {
        ref_key: "canvasRef",
        ref: canvasRef,
        class: "flex-1 overflow-auto p-6 min-h-0",
        onDrop: onCanvasDrop,
        onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, [rows.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_icon, {
        size: 48,
        class: "mb-2"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Grid))]),
        _: 1
      }), _cache[30] || (_cache[30] = _createElementVNode("p", {
        class: "text-sm"
      }, "从左侧拖拽元素到此处，或点击下方\"添加一行\"", -1))])])) : (_openBlock(), _createElementBlock("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row, rowIndex) => {
        return _openBlock(), _createElementBlock("div", {
          key: row.id,
          class: _normalizeClass(["group relative bg-white rounded-lg border p-2 transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300", [isRowOverflow(row) ? 'border-red-400' : 'border-slate-200', flashRowId.value === row.id ? 'ring-2 ring-red-400' : selectedRow.value?.id === row.id ? 'ring-2 ring-primary-300' : '']]),
          style: _normalizeStyle(rowGapStyle(rowIndex)),
          "data-row-id": row.id,
          tabindex: "0",
          onClick: $event => selectRow(row),
          onKeydown: [_withKeys($event => onRowKeydown($event, row), ["enter"]), _withKeys($event => onRowKeydown($event, row), ["space"])]
        }, [_createElementVNode("div", _hoisted_18, [_createElementVNode("button", {
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-slate-50 disabled:opacity-40",
          title: "上移行",
          disabled: rowIndex === 0,
          onClick: _withModifiers($event => moveRowUp(rowIndex), ["stop"])
        }, [_createVNode(_component_el_icon, {
          size: 12
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowUp))]),
          _: 1
        })], 8, _hoisted_19), _createElementVNode("button", {
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-slate-50 disabled:opacity-40",
          title: "下移行",
          disabled: rowIndex === rows.value.length - 1,
          onClick: _withModifiers($event => moveRowDown(rowIndex), ["stop"])
        }, [_createVNode(_component_el_icon, {
          size: 12
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowDown))]),
          _: 1
        })], 8, _hoisted_20), _createElementVNode("button", {
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-red-50 hover:text-red-600",
          title: "删除行",
          onClick: _withModifiers($event => removeRow(rowIndex), ["stop"])
        }, [_createVNode(_component_el_icon, {
          size: 12
        }, {
          default: _withCtx(() => [_createVNode(_unref(Delete))]),
          _: 1
        })], 8, _hoisted_21)]), _createElementVNode("div", {
          class: "export-row-grid flex items-stretch gap-1 min-h-10",
          onDrop: _withModifiers($event => onRowDrop($event, rowIndex), ["stop"]),
          onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
          onDragenter: $event => onRowDragEnter($event, rowIndex),
          onDragleave: $event => onRowDragLeave($event, rowIndex)
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.elements, (element, elementIndex) => {
          return _openBlock(), _createElementBlock("div", {
            key: element.id,
            class: _normalizeClass(["relative flex items-center gap-1 px-2 py-1.5 border rounded text-xs transition-all overflow-hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300", [selectedElement.value?.id === element.id ? 'border-primary-400 bg-primary-50' : 'border-slate-300 bg-white hover:border-slate-400', isElementInvalid(element) ? '!bg-amber-100 !border-amber-400' : '', _unref(BLOCK_ELEMENT_TYPES).includes(element.type) ? 'cursor-pointer' : 'cursor-grab active:cursor-grabbing']]),
            style: _normalizeStyle({
              width: `${(Number(element.span) || 0) / _unref(GRID_SPAN_TOTAL) * 100}%`
            }),
            draggable: !_unref(BLOCK_ELEMENT_TYPES).includes(element.type),
            title: isElementInvalid(element) ? '引用的字段已删除，保存时将被拦截' : '',
            tabindex: "0",
            onDragstart: $event => onElementDragStart($event, rowIndex, elementIndex),
            onDrop: _withModifiers($event => onElementDrop($event, rowIndex, elementIndex), ["stop"]),
            onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
            onClick: _withModifiers($event => selectElement(element), ["stop"]),
            onKeydown: [_withKeys($event => onElementKeydown($event, element), ["enter"]), _withKeys($event => onElementKeydown($event, element), ["space"])]
          }, [resizing.value && resizing.value.elementId === element.id ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(resizing.value.span), 1)) : _createCommentVNode("", true), _createElementVNode("span", {
            class: _normalizeClass(["shrink-0 px-1 rounded text-[10px] leading-4", elementTypeBadgeClass(element.type)])
          }, _toDisplayString(elementTypeBadgeText(element.type)), 3), isElementInvalid(element) ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(_component_el_icon, {
            size: 12,
            class: "text-amber-500 shrink-0"
          }, {
            default: _withCtx(() => [_createVNode(_unref(WarningFilled))]),
            _: 1
          }), _cache[31] || (_cache[31] = _createElementVNode("span", {
            class: "shrink-0 text-[10px] text-amber-600"
          }, "已失效", -1))], 64)) : _createCommentVNode("", true), element.type === _unref(ELEMENT_TYPE_DIVIDER) ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", {
            class: "w-full rounded",
            style: _normalizeStyle({
              height: `${Math.max(1, ptToPx(element.thickness ?? _unref(DIVIDER_DEFAULT_THICKNESS)))}px`,
              backgroundColor: element.color || _unref(DIVIDER_DEFAULT_COLOR)
            })
          }, null, 4)])) : element.type === _unref(ELEMENT_TYPE_SPACER) ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "flex-1 flex items-center justify-center rounded border border-dashed border-slate-300 bg-slate-200/40 text-slate-400",
            style: _normalizeStyle({
              height: `${spacerPreviewHeight(element)}px`
            })
          }, " 空白行（" + _toDisplayString(element.height ?? _unref(SPACER_DEFAULT_HEIGHT)) + " 磅） ", 5)) : element.type === _unref(ELEMENT_TYPE_IMAGE) ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: _normalizeClass(["flex-1 flex py-1", imageAlignClass(element)])
          }, [element.url ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: element.url,
            alt: element.fileName || '图片',
            class: "max-h-20 max-w-full object-contain rounded",
            onError: $event => onImagePreviewError(element)
          }, null, 40, _hoisted_26)) : (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_el_icon, {
            size: 14
          }, {
            default: _withCtx(() => [_createVNode(_unref(Picture))]),
            _: 1
          }), _createElementVNode("span", null, _toDisplayString(element.fileName || '未上传图片'), 1)]))], 2)) : element.type === _unref(ELEMENT_TYPE_DETAIL_TABLE) ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("span", _hoisted_31, _toDisplayString(fieldLabelMap.value[element.fieldKey] || element.fieldKey), 1)]), _cache[32] || (_cache[32] = _createElementVNode("div", {
            class: "space-y-1 px-1.5 py-1"
          }, [_createElementVNode("div", {
            class: "h-1.5 rounded bg-slate-200"
          }), _createElementVNode("div", {
            class: "h-1.5 rounded bg-slate-200"
          })], -1))])])) : element.type === _unref(ELEMENT_TYPE_APPROVAL_TRAIL) ? (_openBlock(), _createElementBlock("div", _hoisted_32, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, i => {
            return _createElementVNode("div", {
              key: i,
              class: "flex items-center gap-1.5"
            }, [...(_cache[33] || (_cache[33] = [_createElementVNode("span", {
              class: "w-2 h-2 rounded-full bg-slate-300 shrink-0"
            }, null, -1), _createElementVNode("span", {
              class: "h-1.5 flex-1 rounded bg-slate-200"
            }, null, -1), _createElementVNode("span", {
              class: "h-1.5 w-8 rounded bg-slate-200 shrink-0"
            }, null, -1)]))]);
          }), 64))])) : (_openBlock(), _createElementBlock("span", {
            key: 7,
            class: "truncate",
            style: _normalizeStyle(elementTextStyle(element))
          }, _toDisplayString(elementLabel(element)), 5)), _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(effectiveSpan)(element)) + "格", 1), _createElementVNode("button", {
            class: "w-6 h-6 flex items-center justify-center shrink-0 rounded text-slate-300 hover:text-red-500",
            title: "删除元素",
            onClick: _withModifiers($event => removeElement(rowIndex, elementIndex), ["stop"])
          }, [_createVNode(_component_el_icon, {
            size: 12
          }, {
            default: _withCtx(() => [_createVNode(_unref(Delete))]),
            _: 1
          })], 8, _hoisted_34), !_unref(BLOCK_ELEMENT_TYPES).includes(element.type) ? (_openBlock(), _createElementBlock("div", {
            key: 8,
            class: "absolute top-0 right-0 w-2 h-full cursor-col-resize rounded-r hover:bg-primary-300/60 z-10",
            title: "拖拽调整宽度",
            onMousedown: $event => startResize($event, rowIndex, element)
          }, null, 40, _hoisted_35)) : _createCommentVNode("", true)], 46, _hoisted_23);
        }), 128)), row.elements.length === 0 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["flex-1 flex items-center justify-center gap-1 border border-dashed rounded py-1.5 text-xs transition-colors", dragOverRowIndex.value === rowIndex ? 'border-primary-400 bg-primary-50 text-primary-500' : 'border-slate-300 text-slate-400'])
        }, [_createVNode(_component_el_icon, {
          size: 12
        }, {
          default: _withCtx(() => [_createVNode(_unref(Plus))]),
          _: 1
        }), _cache[34] || (_cache[34] = _createTextVNode(" 拖入元素到此处 ", -1))], 2)) : _createCommentVNode("", true)], 40, _hoisted_22), isRowOverflow(row) ? (_openBlock(), _createElementBlock("p", _hoisted_36, " 第 " + _toDisplayString(rowIndex + 1) + " 行宽度总和 " + _toDisplayString(rowSpanSum(row)) + " 超出 24 栅格，请调小元素宽度 ", 1)) : _createCommentVNode("", true)], 46, _hoisted_17);
      }), 128))])), _createElementVNode("div", _hoisted_37, [_createElementVNode("button", {
        class: "w-full py-2 border-2 border-dashed border-slate-300 rounded-lg text-sm text-slate-400 hover:border-primary-400 hover:text-primary-600 transition-colors flex items-center justify-center gap-1",
        onClick: addRow
      }, [_createVNode(_component_el_icon, {
        size: 14
      }, {
        default: _withCtx(() => [_createVNode(_unref(Plus))]),
        _: 1
      }), _cache[35] || (_cache[35] = _createTextVNode(" 添加一行 ", -1))])])], 544)]), _createElementVNode("div", _hoisted_38, [_cache[72] || (_cache[72] = _createElementVNode("div", {
        class: "px-4 py-3 border-b border-slate-200 bg-slate-50/50"
      }, [_createElementVNode("h3", {
        class: "text-xs font-semibold text-slate-500 uppercase tracking-wider"
      }, "元素属性")], -1)), _createElementVNode("div", _hoisted_39, [!selectedElement.value && !selectedRow.value ? (_openBlock(), _createElementBlock("p", _hoisted_40, "点击画布中的元素或行进行配置")) : !selectedElement.value && selectedRow.value ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("div", null, [_cache[37] || (_cache[37] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "行号", -1)), _createElementVNode("input", {
        value: `第 ${rows.value.indexOf(selectedRow.value) + 1} 行`,
        class: "form-input form-readonly w-full",
        readonly: ""
      }, null, 8, _hoisted_42)]), _createElementVNode("div", null, [_cache[38] || (_cache[38] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "行前间距（磅，0-72）", -1)), _createVNode(_component_el_input_number, {
        modelValue: selectedRow.value.spacingBefore,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => selectedRow.value.spacingBefore = $event),
        min: 0,
        max: 72,
        class: "form-number w-full"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[39] || (_cache[39] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "行后间距（磅，0-72）", -1)), _createVNode(_component_el_input_number, {
        modelValue: selectedRow.value.spacingAfter,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => selectedRow.value.spacingAfter = $event),
        min: 0,
        max: 72,
        class: "form-number w-full"
      }, null, 8, ["modelValue"])]), _cache[40] || (_cache[40] = _createElementVNode("p", {
        class: "text-xs text-slate-400"
      }, "用于控制导出 Word 中该行与相邻行的间距，留空则不增加额外间距", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_43, [!_unref(BLOCK_ELEMENT_TYPES).includes(selectedElement.value.type) ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_cache[43] || (_cache[43] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "行内位置", -1)), _createElementVNode("div", _hoisted_45, [_createElementVNode("button", {
        class: "btn-secondary flex-1 disabled:opacity-40 disabled:cursor-not-allowed",
        disabled: !canMoveSelectedElement(-1),
        title: "左移元素",
        onClick: _cache[6] || (_cache[6] = $event => moveSelectedElement(-1))
      }, [_createVNode(_component_el_icon, {
        size: 12
      }, {
        default: _withCtx(() => [_createVNode(_unref(ArrowLeft))]),
        _: 1
      }), _cache[41] || (_cache[41] = _createTextVNode(" 左移 ", -1))], 8, _hoisted_46), _createElementVNode("button", {
        class: "btn-secondary flex-1 disabled:opacity-40 disabled:cursor-not-allowed",
        disabled: !canMoveSelectedElement(1),
        title: "右移元素",
        onClick: _cache[7] || (_cache[7] = $event => moveSelectedElement(1))
      }, [_createVNode(_component_el_icon, {
        size: 12
      }, {
        default: _withCtx(() => [_createVNode(_unref(ArrowRight))]),
        _: 1
      }), _cache[42] || (_cache[42] = _createTextVNode(" 右移 ", -1))], 8, _hoisted_47)])])) : _createCommentVNode("", true), _createElementVNode("div", null, [_cache[44] || (_cache[44] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "元素类型", -1)), _createElementVNode("input", {
        value: elementTypeLabel(selectedElement.value.type),
        class: "form-input form-readonly w-full",
        readonly: ""
      }, null, 8, _hoisted_48)]), selectedElement.value.type === _unref(ELEMENT_TYPE_STATIC) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", null, [_cache[45] || (_cache[45] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "文本内容", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => selectedElement.value.content = $event),
        class: "form-input w-full",
        placeholder: "请输入静态文本"
      }, null, 512), [[_vModelText, selectedElement.value.content]])]), _createElementVNode("div", null, [_cache[46] || (_cache[46] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "字号", -1)), _createVNode(_component_el_input_number, {
        modelValue: selectedElement.value.fontSize,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => selectedElement.value.fontSize = $event),
        min: 10,
        max: 36,
        class: "form-number w-full"
      }, null, 8, ["modelValue"])])], 64)) : _createCommentVNode("", true), selectedElement.value.type === _unref(ELEMENT_TYPE_FIELD) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createElementVNode("div", null, [_cache[47] || (_cache[47] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "绑定字段", -1)), _createElementVNode("input", {
        value: selectedElement.value.fieldKey,
        class: "form-input form-readonly w-full",
        readonly: ""
      }, null, 8, _hoisted_49), isElementInvalid(selectedElement.value) ? (_openBlock(), _createElementBlock("p", _hoisted_50, "该字段已被删除，保存时将被拦截")) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createElementVNode("label", _hoisted_51, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => selectedElement.value.showLabel = $event),
        class: "form-switch-input",
        type: "checkbox"
      }, null, 512), [[_vModelCheckbox, selectedElement.value.showLabel]]), _cache[48] || (_cache[48] = _createElementVNode("span", {
        class: "form-switch-track"
      }, null, -1)), _cache[49] || (_cache[49] = _createElementVNode("span", {
        class: "form-switch-label"
      }, "显示字段名", -1))]), _cache[50] || (_cache[50] = _createElementVNode("p", {
        class: "mt-1 text-xs text-slate-400"
      }, "开启后导出为\"字段名：值\"形态，关闭则只导出值", -1))]), _createElementVNode("div", null, [_cache[51] || (_cache[51] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "字号", -1)), _createVNode(_component_el_input_number, {
        modelValue: selectedElement.value.fontSize,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => selectedElement.value.fontSize = $event),
        min: 10,
        max: 36,
        class: "form-number w-full"
      }, null, 8, ["modelValue"])])], 64)) : _createCommentVNode("", true), selectedElement.value.type === _unref(ELEMENT_TYPE_DETAIL_TABLE) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 3
      }, [_createElementVNode("div", null, [_cache[52] || (_cache[52] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "绑定明细表", -1)), _createElementVNode("input", {
        value: selectedElement.value.fieldKey,
        class: "form-input form-readonly w-full",
        readonly: ""
      }, null, 8, _hoisted_52), isElementInvalid(selectedElement.value) ? (_openBlock(), _createElementBlock("p", _hoisted_53, "该明细表已被删除，保存时将被拦截")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_54, [_withDirectives(_createElementVNode("input", {
        id: "export-el-border",
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => selectedElement.value.border = $event),
        type: "checkbox",
        class: "form-check"
      }, null, 512), [[_vModelCheckbox, selectedElement.value.border]]), _cache[53] || (_cache[53] = _createElementVNode("label", {
        for: "export-el-border",
        class: "text-sm text-slate-700"
      }, "显示表格边框", -1))])], 64)) : _createCommentVNode("", true), selectedElement.value.type === _unref(ELEMENT_TYPE_APPROVAL_TRAIL) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 4
      }, [_createElementVNode("div", _hoisted_55, [_withDirectives(_createElementVNode("input", {
        id: "export-el-comment",
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => selectedElement.value.showComment = $event),
        type: "checkbox",
        class: "form-check"
      }, null, 512), [[_vModelCheckbox, selectedElement.value.showComment]]), _cache[54] || (_cache[54] = _createElementVNode("label", {
        for: "export-el-comment",
        class: "text-sm text-slate-700"
      }, "显示审批意见", -1))]), _createElementVNode("div", _hoisted_56, [_withDirectives(_createElementVNode("input", {
        id: "export-el-time",
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => selectedElement.value.showTime = $event),
        type: "checkbox",
        class: "form-check"
      }, null, 512), [[_vModelCheckbox, selectedElement.value.showTime]]), _cache[55] || (_cache[55] = _createElementVNode("label", {
        for: "export-el-time",
        class: "text-sm text-slate-700"
      }, "显示审批时间", -1))])], 64)) : _createCommentVNode("", true), selectedElement.value.type === _unref(ELEMENT_TYPE_DIVIDER) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 5
      }, [_createElementVNode("div", null, [_cache[56] || (_cache[56] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "线条粗细（磅，0.5-10）", -1)), _createVNode(_component_el_input_number, {
        modelValue: selectedElement.value.thickness,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => selectedElement.value.thickness = $event),
        min: 0.5,
        max: 10,
        step: 0.5,
        class: "form-number w-full"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[57] || (_cache[57] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "线条颜色", -1)), _createVNode(_component_el_color_picker, {
        modelValue: selectedElement.value.color,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => selectedElement.value.color = $event)
      }, null, 8, ["modelValue"])])], 64)) : _createCommentVNode("", true), selectedElement.value.type === _unref(ELEMENT_TYPE_SPACER) ? (_openBlock(), _createElementBlock("div", _hoisted_57, [_cache[58] || (_cache[58] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "空白高度（磅，0-200）", -1)), _createVNode(_component_el_input_number, {
        modelValue: selectedElement.value.height,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => selectedElement.value.height = $event),
        min: 0,
        max: 200,
        class: "form-number w-full"
      }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), selectedElement.value.type === _unref(ELEMENT_TYPE_IMAGE) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 7
      }, [_createElementVNode("div", null, [_cache[59] || (_cache[59] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, [_createTextVNode("图片 "), _createElementVNode("span", {
        class: "text-red-500"
      }, "*")], -1)), _createVNode(FileUpload, {
        files: imageFiles.value,
        accept: "image/*",
        "max-count": 1,
        "max-size": 5,
        "onUpdate:files": onImageFilesUpdate
      }, null, 8, ["files"]), !selectedElement.value.fileKey ? (_openBlock(), _createElementBlock("p", _hoisted_58, "未上传图片，保存时将被拦截")) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_cache[60] || (_cache[60] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "图片宽度（毫米，10-160）", -1)), _createVNode(_component_el_input_number, {
        modelValue: selectedElement.value.width,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => selectedElement.value.width = $event),
        min: 10,
        max: 160,
        class: "form-number w-full"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[64] || (_cache[64] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "对齐方式", -1)), _createVNode(_component_el_radio_group, {
        modelValue: selectedElement.value.align,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => selectedElement.value.align = $event),
        size: "small"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_button, {
          value: "left"
        }, {
          default: _withCtx(() => [...(_cache[61] || (_cache[61] = [_createTextVNode("左", -1)]))]),
          _: 1
        }), _createVNode(_component_el_radio_button, {
          value: "center"
        }, {
          default: _withCtx(() => [...(_cache[62] || (_cache[62] = [_createTextVNode("中", -1)]))]),
          _: 1
        }), _createVNode(_component_el_radio_button, {
          value: "right"
        }, {
          default: _withCtx(() => [...(_cache[63] || (_cache[63] = [_createTextVNode("右", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])])], 64)) : _createCommentVNode("", true), [_unref(ELEMENT_TYPE_STATIC), _unref(ELEMENT_TYPE_FIELD)].includes(selectedElement.value.type) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 8
      }, [_createElementVNode("div", null, [_cache[68] || (_cache[68] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "对齐方式", -1)), _createVNode(_component_el_radio_group, {
        modelValue: selectedElement.value.align,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => selectedElement.value.align = $event),
        size: "small"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_button, {
          value: "left"
        }, {
          default: _withCtx(() => [...(_cache[65] || (_cache[65] = [_createTextVNode("左", -1)]))]),
          _: 1
        }), _createVNode(_component_el_radio_button, {
          value: "center"
        }, {
          default: _withCtx(() => [...(_cache[66] || (_cache[66] = [_createTextVNode("中", -1)]))]),
          _: 1
        }), _createVNode(_component_el_radio_button, {
          value: "right"
        }, {
          default: _withCtx(() => [...(_cache[67] || (_cache[67] = [_createTextVNode("右", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_59, [_withDirectives(_createElementVNode("input", {
        id: "export-el-bold",
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => selectedElement.value.bold = $event),
        type: "checkbox",
        class: "form-check"
      }, null, 512), [[_vModelCheckbox, selectedElement.value.bold]]), _cache[69] || (_cache[69] = _createElementVNode("label", {
        for: "export-el-bold",
        class: "text-sm text-slate-700"
      }, "加粗", -1))]), _createElementVNode("div", null, [_cache[70] || (_cache[70] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "文字颜色", -1)), _createVNode(_component_el_color_picker, {
        modelValue: selectedElement.value.color,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => selectedElement.value.color = $event)
      }, null, 8, ["modelValue"])])], 64)) : _createCommentVNode("", true), !_unref(BLOCK_ELEMENT_TYPES).includes(selectedElement.value.type) ? (_openBlock(), _createElementBlock("div", _hoisted_60, [_cache[71] || (_cache[71] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "栅格宽度（1-24）", -1)), _createVNode(_component_el_input_number, {
        modelValue: selectedElement.value.span,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => selectedElement.value.span = $event),
        min: 1,
        max: 24,
        class: "form-number w-full"
      }, null, 8, ["modelValue"])])) : _createCommentVNode("", true)]))])])]);
    };
  }
};